export default __webpack_public_path__ + "static/media/banner-01.dc399bc5.webp";